import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

const Title = styled.h1`
    font-size: 12px;
    font-weight: normal;
`;

const WrapperWithLine = styled.div`
    border-left: 2px solid gray;
    padding-left: 10px;
`;

/**
 * The TooltipContent will be called for each stacked bar (guaranteed, nonGuaranteed)
 * The entire content is drawn at once, so ignore the second call (nonGuaranteed)
 */
const TooltipContent = ({ type, sections, messages, row }) =>
    type === 'guaranteed' &&
    sections.map(({ key, titleMessage, getGuaranteedValue, getNonGuaranteedValue }) => (
        <React.Fragment key={key}>
            <Title>
                <FormattedMessage {...titleMessage} />
            </Title>
            <WrapperWithLine>
                <p>
                    <FormattedMessage {...messages.guaranteed} values={{ value: getGuaranteedValue(row) }} />
                </p>
                <p>
                    <FormattedMessage {...messages.nonGuaranteed} values={{ value: getNonGuaranteedValue(row) }} />
                </p>
            </WrapperWithLine>
        </React.Fragment>
    ));

export default TooltipContent;
